import { createRouter, createWebHashHistory, type Router } from 'vue-router';

/**
 * 首页去 # 逻辑：当路由切到 / 时，用 replaceState 把 URL 中的 hash 去掉，
 * 让首页 URL 保持干净。其他路由保持正常的 #/xxx hash 模式。
 */
function setupHomeCleanUrl(router: Router) {
  const stripHash = () => {
    if (window.location.hash) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  };

  router.afterEach((to) => {
    if (to.path === '/') stripHash();
  });

  // 首次加载：如果 hash 为空或为 #/，也清理
  if (!window.location.hash || window.location.hash === '#/' || window.location.hash === '#') {
    stripHash();
  }
}

/**
 * 根据当前页面 URL 推断 editor 子应用的基础路径。
 * 例如当前页面为 https://res.cymini.qq.com/team6-base/dev/gs-viewer2/index.html
 * 则 editor base 为 https://res.cymini.qq.com/team6-base/dev/gs-viewer2/editor
 */
function getEditorBaseUrl(): string {
  const { origin, pathname } = window.location;
  const dir = pathname.replace(/\/[^/]*$/, '');
  return `${origin}${dir}/editor`;
}

const routes = [
  {
    path: '/',
    name: 'ModelList',
    component: () => import('../pages/ModelList.vue'),
    meta: { title: 'Web Wide World' },
  },
  {
    path: '/viewer2',
    name: 'viewer2',
    component: () => import('../pages/scene-viewer/SceneViewer.vue'),
    props: true,
  },
  {
    path: '/debug-viewer',
    name: 'debugViewer',
    component: () => import('../pages/scene-viewer/DebugSceneViewer.vue'),
    meta: { title: 'Debug Scene Viewer' },
    props: true,
  },
  {
    path: '/creative',
    name: 'creativeViewer',
    component: () => import('../pages/creative-viewer/CreativeViewer.vue'),
    meta: { title: 'Creative Mode Test' },
  },
  // Editor 子应用跳转：重定向到 COS 上独立部署的页面
  {
    path: '/editor/navigator/:pathMatch(.*)*',
    name: 'editorNavigator',
    beforeEnter: () => {
      window.location.href = `${getEditorBaseUrl()}/navigator/index.html`;
      return false;
    },
    component: { render: () => null },
  },
  {
    path: '/editor/splat-studio/:pathMatch(.*)*',
    name: 'editorSplatStudio',
    beforeEnter: () => {
      window.location.href = `${getEditorBaseUrl()}/splat-studio/index.html`;
      return false;
    },
    component: { render: () => null },
  },
  {
    path: '/editor/file-converter/:pathMatch(.*)*',
    name: 'editorFileConverter',
    beforeEnter: () => {
      window.location.href = `${getEditorBaseUrl()}/file-converter/index.html`;
      return false;
    },
    component: { render: () => null },
  },
  {
    path: '/editor/meta-editor/:pathMatch(.*)*',
    name: 'editorMetaEditor',
    beforeEnter: () => {
      window.location.href = `${getEditorBaseUrl()}/meta-editor/index.html`;
      return false;
    },
    component: { render: () => null },
  },
  {
    path: '/editor/map-editor/:pathMatch(.*)*',
    name: 'editorMapEditor',
    beforeEnter: () => {
      window.location.href = `${getEditorBaseUrl()}/map-editor/index.html`;
      return false;
    },
    component: { render: () => null },
  },
  {
    path: '/editor/character-editor/:pathMatch(.*)*',
    name: 'editorCharacterEditor',
    beforeEnter: () => {
      window.location.href = `${getEditorBaseUrl()}/character-editor/index.html`;
      return false;
    },
    component: { render: () => null },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 首页去 #：URL 保持干净
setupHomeCleanUrl(router);

router.beforeEach((to, _from, next) => {
  if (to.meta.title) {
    // @ts-ignore
    document.title = to.meta.title;
  }
  next();
});
export default router;
